<div class="input-top" [style.flexDirection]="multiController.exampleShow ? 'column' : 'row'">
  <div class="input_timer">
    <msl-timer
      *ngIf="multiController.showTimer"
      class="table_timer"
      [small]="true"
      [color]="multiController.color.primary.s500"
      [fontColor]="multiController.color.primary.font"
      [width]="multiController.timerWidth"
    ></msl-timer>
  </div>

  <div *ngIf="multiController.exampleShow" class="example-wrapper" msOrchestratorBlock="example">
    <ms-multi-example [example]="multiController.example" msOrchestratorBlock="exampleText"></ms-multi-example>
  </div>

  <!-- START: РЕЖИМ ДИКТАНТА -->
  <div *ngIf="multiController.showDictationEnter" class="enter-answer">
    <div msOrchestratorBlock="dictationHeader">
      <div
        class="enter-answer_title"
        [ngStyle]="{
                  'color': multiController.operator.appearance.theme.colors.border,
                }"
      >{{ multiController.dictationExampleNumber }}</div>
      <div
        class="enter-answer_suffix"
        [ngStyle]="{
                  'color': multiController.operator.appearance.theme.colors.border,
                }"
      >{{ 'task' | translate }}</div>
    </div>
    <msl-timer
      [color]="multiController.operator.appearance.theme.colors.border"
      [fontColor]="multiController.color.primary.font"
      class="enter-answer_timer"
      [width]="multiController.dictationTime"
    ></msl-timer>
    <div
      class="enter-answer_subtitle"
      msOrchestratorBlock="dictationSubtitle"
      [ngStyle]="{
                'color': multiController.operator.appearance.theme.colors.border,
              }"
    >{{ 'menar.writeAnswer' | translate }}</div>

    <div *ngIf="multiController.isDictationWithAnswerInput" class="inputs inputs__dictation">
      <ms-answer-entry-form
        msOrchestratorBlock="dictationAnswerEntry"
        [appearance]="multiController.answerEntryAppearance()"
        [formControl]="multiController.userAnswer.control"
        [readonly]="multiController.isMobile || multiController.isAnswer"
        [numeralSystem]="multiController.numeralSystem"
        type="likeNumber"
        [submitButton]="false"
        (inputInput)="multiController.resetWrongAnswer()"
        (inputSubmit)="multiController.makeDictationModeAnswer()"
        (inputCalculatorSubmit)="multiController.makeDictationModeAnswer()"
      ></ms-answer-entry-form>
      <div *ngIf="!multiController.calculator" class="input-bottom" msOrchestratorBlock="dictationButtonContainer">
        <button msGameButton color="orange" (click)="multiController.makeDictationModeAnswer()" tabindex="-1"
                class="input-button" msOrchestratorBlock="dictationButton">
          {{ 'check' | translate }}
        </button>
      </div>
    </div>
  </div>
  <!-- END: РЕЖИМ ДИКТАНТА -->
</div>

<!-- ВВОД ОТВЕТА -->
<ms-answer-entry-form
  *ngIf="multiController.isInput"
  [class.olympiad-preview-hidden]="multiController.isOlympiadStudentPreviewActive"
  msOrchestratorBlock="answerEntry"
  type="likeNumber"
  [appearance]="multiController.answerEntryAppearance()"
  [formControl]="multiController.userAnswer.control"
  [readonly]="multiController.isMobile || multiController.isAnswer"
  [numeralSystem]="multiController.numeralSystem"
  [submitButton]="multiController.canAnswer"
  (inputClick)="multiController.onInputClick()"
  (valueChanges)="multiController.changeValueAnswer($event)"
  (inputInput)="multiController.resetWrongAnswer()"
  (inputBlur)="multiController.syncAnswer()"
  (inputSubmit)="multiController.answer()"
  (inputCalculatorSubmit)="multiController.answer()"
></ms-answer-entry-form>
